import React, { useState, useEffect } from 'react';
import { AppContextProvider } from '../contexts';
import { ContextualizedApp } from '../app';
import { CircularProgress } from "@mui/joy";
import { Backdrop } from "@mui/material";
import { useDataProvider } from '../../mtska-frontend-data-provider';
import { useTranslation } from 'react-i18next';
import * as Modules from '../../mtska-frontend-modules';
import '../../mtska-frontend-app-component/styles/components.scss';
import { useWindowDimensions } from './../hooks/useWindowDimensions'
import { useLegalEntityOptions } from './app.hooks';

const App = () => {

    const { innerHeight, innerWidth } = useWindowDimensions();

    const { i18n } = useTranslation();


    const { loadOne } = useDataProvider('auth/token');
    const { item: config, loadOne: loadConfig } = useDataProvider('configs/config');
    const { loadAll: loadSettings, save: saveSetting } = useDataProvider('settings/setting');
    const { item: appconfig, loadOne: loadAppConfig } = useDataProvider('applications/app');
    const { item: moduleconfig, loadOne: loadModuleConfig } = useDataProvider('applications/module');

    const [appConfiguration, setAppConfiguration] = useState()
    const [userCapabilities, setUserCapabilities] = useState()
    const [existingModules, setExistingModules] = useState()
    const [settings, setSettings] = useState()
    const [filterByLegalEntity, setFilterByLegalEntity] = useState()

    const t = sessionStorage.getItem('token')

    useEffect(() => {

        loadAppConfig('670e3907863d1b0bfa9706b9').then((response) => {
            if (response && response.item && response.item.data) {
                response.item.data.modules.active = response.item.data.modules.active.map((module) => Modules[module]).filter((item) => { return item !== undefined })
                //console.info('Moduli attivi in App.js - se non trovi il tuo modulo al 99% non lo hai linkato in index.js di root di mtska-frontend-modules', response.item.data.modules.active);
                //console.info('Moduli dichiarati in index.js', Modules);
                setAppConfiguration(response.item.data);
            }
        });

        loadModuleConfig('0').then((response) => {
            if (response && response.item && response.item.data) {
                setExistingModules(response.item.data);
            }
        });

        if (t != null) {
            loadOne(sessionStorage.getItem('token')).then((response) => {
                response?.item?.data?.locale && i18n.changeLanguage(response.item.data.locale);
            });
            loadConfig(sessionStorage.getItem('token')).then((response) => {
                if (response && response.item && response.item.data) {
                    setUserCapabilities(response.item.data.capabilities);
                }
            });

            !settings && loadSettings(sessionStorage.getItem('token')).then((res) => {
                const { items = {} } = res
                const { data = {} } = items
                const { selectedLegalEntity = {} } = data
                const { id } = selectedLegalEntity
                setSettings(data)
                setFilterByLegalEntity(id)
            })
        } else {
            setUserCapabilities([]);
        }
    }, [t])

    const { loadAll } = useDataProvider('companies/selectablelegalentity')
    const { legalEntityOptions, setLegalEntityOptions } = useLegalEntityOptions({ appConfiguration, loadAll, settings })

    const concreteconfig = {
        appConfiguration,
        existingModules,
        filterByLegalEntity,
        innerHeight,
        innerWidth,
        legalEntityOptions,
        saveSetting,
        settings,
        setFilterByLegalEntity,
        setLegalEntityOptions,
        setSettings,
        userCapabilities,
        setUserCapabilities
    }

    return (
        (appConfiguration && userCapabilities && existingModules) ? (
            <AppContextProvider concreteconfig={concreteconfig}>
                <ContextualizedApp />
            </AppContextProvider>
        ) : (
            <Backdrop open={true}>
                <CircularProgress />
            </Backdrop>
        )
    )
}

export default App;